import request from "@/plugins/axios"
//发票板式文件审核
let prefix = "eids-invoice/orgfin"

export function pageList(criteria) {
  return request({
    url: prefix + '/pagelist',
    method: 'post',
    data: criteria,
  })
}

export function myOrgFin() {
  return request({
    url: prefix + '/myOrgFin',
    method: 'get',
  })
}

export function orgFin(orgId) {
  return request({
    url: prefix + '/orgFin/' + orgId,
    method: 'get',
  })
}

export function priceSetting(data) {
  return request({
    url: prefix + '/priceSetting',
    method: 'post',
    data: data,
  })
}
